import React, { useMemo } from 'react';
import { Button, Box, Alert } from '@mui/material';
import { formPrimaryButtonSx } from './styles';

const formatErrors = (errors) => {
  if (!errors) {
    return null;
  }

  if (typeof errors === 'string') {
    return errors;
  }

  if (Array.isArray(errors)) {
    return errors.join(' / ');
  }

  if (typeof errors === 'object') {
    const messages = Object.entries(errors).map(([field, fieldErrors]) => {
      const detail = Array.isArray(fieldErrors)
        ? fieldErrors.join('、')
        : fieldErrors;
      return `${field}: ${detail}`;
    });

    if (messages.length > 0) {
      return messages.join(' / ');
    }
  }

  return null;
};

const BaseForm = ({ children, onSubmit, submitLabel, logMessage, apiError, disableEnterSubmit = false }) => {
  const handleOnSubmit = (event) => {
    event.preventDefault();
    console.log(logMessage);
    onSubmit(event);
  };

  const handleKeyDown = (event) => {
    if (!disableEnterSubmit || event.key !== 'Enter') {
      return;
    }

    if (event.target.tagName === 'TEXTAREA') {
      return;
    }

    event.preventDefault();
  };

  const errorMessage = useMemo(() => {
    if (!apiError) {
      return '';
    }

    const responseData = apiError.response?.data;

    if (responseData) {
      if (responseData.message) {
        return responseData.message;
      }

      const validationMessage = formatErrors(responseData.errors);
      if (validationMessage) {
        return validationMessage;
      }

      if (responseData.error) {
        const message = formatErrors(responseData.error);
        if (message) {
          return message;
        }
      }

      if (typeof responseData === 'string') {
        return responseData;
      }
    }

    if (typeof apiError === 'string') {
      return apiError;
    }

    if (apiError.message) {
      return apiError.message;
    }

    return 'エラーが発生しました。';
  }, [apiError]);

  return (
    <Box component="form"
      sx={{
        width: '100%',
        maxWidth: { xs: '340px', sm: '600px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 3,
        margin: '0 auto',
        padding: 2,
        backgroundColor: '#fff',
      }}
      onSubmit={handleOnSubmit}
      onKeyDown={handleKeyDown}
    >
      {children}
      {errorMessage && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {errorMessage}
        </Alert>
      )}
      <Button type="submit" variant="contained" disableElevation sx={formPrimaryButtonSx}>{submitLabel}</Button>
    </Box>
  );
};

export default BaseForm;
